import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=44d38504&scoped=true&"
import script from "./NoticeModal.vue?vue&type=script&lang=js&"
export * from "./NoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&id=44d38504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d38504",
  null
  
)

export default component.exports